import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import _ from 'lodash'
import consultation from './modules/consultation'

// import { cloneDeep } from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    consultation
  },

  state: {
    isLoad: false,
    main: {},
    fleet: {},
    currentPage: '',
    deviceSize: {
      width: 0,
      height: 0
    },
    marketing: JSON.parse(localStorage.getItem('marketing')),
    stockPolicy: JSON.parse(localStorage.getItem('stockPolicy')),
    marketing: JSON.parse(localStorage.getItem('marketing')),
    currentLang: 'uk',
    currentCountry: 'ua',
    globalData: ''
  },
  getters: {
    getStockPolicy: state => state.stockPolicy,
    getMarketing: state => state.marketing,
    getMain: state => state.main,
    getFleet: state => state.fleet,
    scriptsHeadBody: state => state.main.scripts,
    isLoad: state => state.isLoad,
    getEnv: state => this.process.env.VUE_APP_API_URL,
    isMobile: state => state.deviceSize.width < 768,
    isTablet: state => state.deviceSize.width >= 768 && state.deviceSize.width < 1280,
    isDesktop: state => state.deviceSize.width >= 1280,
    getPhoneType: state => {
      if (state.currentCountry === 'md') {
        return '+373'
      } else {
        return '+380'
      }
    }
  },
  actions: {
    async fetchGlobalData ({ commit }) {
      try {
        const { data } = await window.axios.get('/global-data')
        commit('setGlobalData', data)
      } catch (err) {
        console.error('FAILED: fetchGlobalData')
        console.error(err)
      }
    },

    async fetchGeneralData ({ getters, commit }) {
      try {
        const { data } = await window.axios.get(window.location.pathname,
          { params: {
            lang: router.currentRoute.query ? router.currentRoute.query.lang : '',
            country: router.currentRoute && router.currentRoute.query ? router.currentRoute.query.country : ''
          }
          })

        commit('setGeneralData', data.data)
      } catch (err) {
        if (_.isEmpty(getters.getStockPolicy)) {
          console.error('FAILED: fetchGeneralData')
          console.error(err)
          router.push({ name: 'not-found' })
        }
      } finally {
        commit('setIsLoad')
      }
    },
    async fetchFleetPageData ({ getters, commit }) {
      try {
        const { data } = await window.axios.get(router.currentRoute.fullPath)
        commit('setFleetPageData', data.data)
        commit('setGeneralData', data.data || data)
        return Promise.resolve(data)
      } catch (err) {
        console.log(err)
        if (_.isEmpty(getters.getStockPolicy)) {
          console.error('FAILED: fetchFleetPageData')
          console.error(err)
          router.push({ name: 'not-found' })
        }
        return Promise.reject(err)
      } finally {
        commit('setIsLoad')
      }
    },
    async submitServiceRequest (store, { submitUrl, form, formName }) {
      let params = {}
      if ((_.get(router, 'app.$route.query.dealerId') || _.get(router, 'app.$route.query.dealerName') || _.get(router, 'app.$route.query.dealer')) && formName !== 'fleet') {
        params = {
          iframe: 1
        }
      }
      const { data } = await window.axios.post(submitUrl, form, {
        params: params
      })
      return data
    },
    async fetchPolicyPageData () {
      try {
        const { data } = await window.axios.get('/policy')
        return data.data
      } catch (err) {
        console.error('FAILED: fetchPolicyPageData')
        console.error(err)
        router.push({ name: 'not-found' })
      }
    },
    async fetchThankYouPageData () {
      try {
        const { data } = await window.axios.get('/thank-you')
        return data.data
      } catch (err) {
        console.error('FAILED: fetchThankYouPageData')
        console.error(err)
        router.push({ name: 'not-found' })
      }
    }
  },
  mutations: {
    setGlobalData (state, payload) {
      state.globalData = payload
    },
    setCurrentLang (state, payload) {
      state.currentLang = payload.toLowerCase()
      window.axios.defaults.headers.common['Accept-Language'] = payload
    },
    setCurrentCountry (state, payload) {
      state.currentCountry = payload.toLowerCase()
    },
    setGeneralData (state, newGeneralData) {
      state.main = newGeneralData
    },
    setFleetPageData (state, newFleetPageData) {
      state.fleet = newFleetPageData
    },
    setDeviceWidth (state, width) {
      state.deviceSize.width = width
    },
    setIsLoad (state) {
      clearInterval(window.titleChangeFn)
      window.document.title = _.get(state, 'main.title', '') || _.get(state, 'fleet.title', '') || 'no title'
      state.isLoad = true
    },
    setIsLoadFleet (state) {
      clearInterval(window.titleChangeFn)
      window.document.title = state.fleet.title || 'no title'
      state.isLoad = true
    },
    setDeviceHeight (state, height) {
      state.deviceSize.height = height
    },
    setStockPolicy (state, payload) {
      state.stockPolicy = payload
    },
    setMarketing (state, payload) {
      state.marketing = payload
    },
    clearStockPolicy (state) {
      state.stockPolicy = {}
    }
  }
})
